import React from "react";
import T from "./Translate/T";

const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2"><T>About Me</T></span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          <T>Know Me More</T>
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              <T>Hi, I'm</T>{" "}
              <span className="fw-700 border-bottom border-3 border-primary">
                Carlos A. Ramirez
              </span>
            </h2>
            <p className="text-5">
              <T>Senior Full Stack Engineer and system architect with 13+ years of experience delivering enterprise-grade web platforms for Canadian and international clients including Scotiabank, TELUS, Aviva, and Air Miles.</T>
              {" "}
              <T>Specializes in PHP/Laravel API architecture, Next.js, React front-ends, and AWS cloud infrastructure.</T>
              {" "}
              <T>Proven track record migrating legacy systems, architecting microservices, and leading cross-functional teams in agile environments.</T>
              {" "}
              <T>Bilingual (English/Spanish) with deep familiarity with both North American and Latin American business contexts, uniquely positioned for remote roles bridging LATAM and global markets.</T>
            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  10+
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                <T>Years of</T> <span className="fw-700"><T>Experience</T></span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0"><T>Name:</T></p>
            <p className="text-4 text-dark fw-600 mb-0">Carlos A. Ramirez</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0"><T>Email:</T></p>
            <p className="text-4 fw-600 mb-0">
              <a className="link-dark" href="mailto:carlosa.ramirez.e@gmail.com">
                carlos.a.ramirez.e@gmail.com
              </a>
            </p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
            {/* <p className="text-muted fw-500 mb-0">Date of birth:</p>
            <p className="text-4 text-dark fw-600 mb-0">11 November, 1987</p> */}
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            {/* <p className="text-muted fw-500 mb-0">From:</p> */}
            {/* <p className="text-4 text-dark fw-600 mb-0">Toronto, Canada.</p> */}
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutUs;